export const BUTTON_TYPE = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    TERTIARY: "tertiary",
  };
  
  export const BUTTON_SIZE = {
    LARGE: "large",
    MEDIUM: "medium",
    SMALL: "small",
  };



  export const BUTTON_SIZE_TO_CSS_CLASS_MAP = {
    [BUTTON_SIZE.LARGE] : 'btn-large',
    [BUTTON_SIZE.MEDIUM] : 'btn-medium',
    [BUTTON_SIZE.SMALL] : 'btn-small',
  }